'use strict';

const basicOptions = {
    dataUrl: '',

    loaded: false,

    isLoadedPromise: null,

    loadedTrigger: null,

    initialize() {
        this.isLoadedPromise = $.Deferred();
        this.populateData();
    },

    load() {
        this.populateData();
    },

    forceLoad() {
        this.isLoadedPromise = $.Deferred();
        this.load();
        return this.isLoadedPromise;
    },

    url() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },

    preFetch() {

    },

    postFetch() {

    },

    populateData() {
        this.loaded = false;
        this.preFetch();
        this.fetch(this.getDataRequestSettings());
    },

    getDataRequestSettings() {
        return {
            type: 'GET',
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            success: Odigeo._.bind(this.requestSuccessHandler, this),
            error: Odigeo._.bind(this.requestErrorHandler, this),
        };
    },

    requestSuccessHandler() {
        this.postFetch();
        this.loaded = true;
        this.isLoadedPromise.resolve(true);

        if (this.loadedTrigger) {
            this.trigger(this.loadedTrigger);
        }
    },

    requestErrorHandler() {
        this.loaded = false;
        this.isLoadedPromise.resolve(false);
    },

    isLoaded() {
        return this.loaded;
    },

    getLoadedPromise() {
        return this.isLoadedPromise.promise();
    },
};

const getCombinedOptions = (options) => Odigeo._.extend({}, basicOptions, options);

const getCollection = (options) => Odigeo.Model.extend(getCombinedOptions(options));

module.exports = (options = {}) => {
    let instance;

    return {
        getInstance() {
            if (Odigeo._.isUndefined(instance)) {
                instance = new (getCollection(options));
            }

            return instance;
        },
    };
};
